import React, {useMemo} from 'react';

const colors = ['#69D994', '#9DDEAD', '#B3E5C2', '#E5F6EB'];
const pathCount = 7;
const circleCount = 5;

const randRange = (min: number, max: number) => (
	Math.random() * (max - min) + min
);

const useCircleConveyor = () => (
	useMemo(() => {
		const generated: JSX.Element[] = [];
		for (let pathIndex = 0; pathIndex < pathCount; pathIndex++) {
			const yPos = (100 / pathCount) + pathIndex * (100 / pathCount);
			const direction = pathIndex % 2 === 0 ? 1 : -1;
			const colorIndex = pathIndex % 4;

			// Create a wavy path
			const pathAmplitude = randRange(5, 15);
			const path = `M 0 ${yPos} Q 25 ${yPos + pathAmplitude}, 50 ${yPos} T 100 ${yPos}`;

			// Add the path (semi-transparent)
			generated.push(
				<path
					key={`path-${pathIndex}`}
					d={path}
					fill='none'
					stroke={colors[0]}
					strokeWidth='0.5'
					strokeDasharray='1,1'
					opacity='0.3'
				/>
			);

			// Add circles on the path
			for (let i = 0; i < circleCount; i++) {
				const circleSize = randRange(2, 5);
				const duration = randRange(12, 18);
				const delay = (i / circleCount) * duration;

				generated.push(
					<circle
						key={`conveyor-${pathIndex}-${i}`}
						r={circleSize}
						fill={colors[colorIndex]}
						opacity='0.8'
					>
						<animateMotion
							path={path}
							dur={`${duration}s`}
							begin={`${delay}s`}
							repeatCount='indefinite'
							calcMode='linear'
							keyPoints={direction > 0 ? '0;1' : '1;0'}
							keyTimes='0;1'
							rotate='auto'
						/>
					</circle>
				);

				// Add smaller trailing circles for some
				if (i % 2 === 0) {
					const trailSize = circleSize * 0.6;
					const trailDelay = delay + 0.5;

					generated.push(
						<circle
							key={`trail-${pathIndex}-${i}`}
							r={trailSize}
							fill={colors[(colorIndex + 1) % 4]}
							opacity='0.6'
						>
							<animateMotion
								path={path}
								dur={`${duration}s`}
								begin={`${trailDelay}s`}
								repeatCount='indefinite'
								calcMode='linear'
								keyPoints={direction > 0 ? '0;1' : '1;0'}
								keyTimes='0;1'
								rotate='auto'
							/>
						</circle>
					);
				}
			}
		}
		return generated;
	}, [])
);

export const CircleConveyor: React.FC = () => {
	const elements = useCircleConveyor();
	return (
		<div>
			<svg
				width='100%'
				height='100%'
				viewBox='0 0 100 100'
				preserveAspectRatio='none'
			>
				{elements}
			</svg>
		</div>
	);
};
